<app-loader *ngIf="isDisabled"></app-loader>
<div class="card">
    <div class="card-header">
        <div class="row">
            <div class="col">User Profile</div>
        </div>
    </div>
    <div class="card-body" style="overflow: auto; height: 450px;">
        <div class="container">
            <div class="card" style="border-radius: 0%;">
                <div class="card-header">
                    Personal Details
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-md mx-1 px-1 bghighlight">
                            <label class="small-light-label heading">Employee</label><br />
                            <label class="Label1">
                                <!-- {{InputData.EmpName}}({{InputData.EmpCode}}) -->
                                <div class="row no-gutters cursor-pointer" style="align-items: center;width: 300px;">
                                    <div class="col-2">
                                        <img *ngIf="ViewData[0].Photo != null && ViewData[0].Photo!= ''" mat-card-image
                                            class="userImage" [src]="common.PhotoLink(ViewData[0].Photo)" />
                                        <div *ngIf="ViewData[0].Photo == null || ViewData[0].Photo == ''"
                                            class="initial-image">
                                            <div class="image">
                                                {{common.getInitial(ViewData[0].EmpName)}}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-9 userdetail">
                                        <span class="text-label">{{ViewData[0].EmpName}}</span><br />
                                        <span class="text-label-light">#{{ViewData[0].EmpCode}}</span><br />
                                        <span class="text-label-light">{{ViewData[0].DesignationName}}</span>
                                    </div>
                                </div>
                            </label>
                        </div>
                        <!-- <div class="col-md-4">
                            <label class="small-light-label heading">Contact</label><br />
                            <label class="Label1">{{ViewData[0].ContactNo}} </label>
                        </div> -->
                        <div class="col-md mx-1 px-1 bghighlight">
                            <div class="row">
                                <div class="text-label">Contact</div>
                            </div>
                            <div class="row text-right">
                                <div>{{ViewData[0].ContactNo}}</div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1 bghighlight">
                            <div class="row">
                                <div class="text-label">Emergency Contact Number</div>
                            </div>
                            <div class="row text-right">
                                <div>{{ViewData[0].EmergencyContactNo}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="row" style="margin-top: 3px;">
                        <div class="col-md mx-1 px-1 bghighlight">
                            <div class="row">
                                <div class="text-label">Local Address</div>
                            </div>
                            <div class="row text-right">
                                <div>{{ViewData[0].LocalAddress}} </div>
                            </div>
                        </div>
                        <div class="col-md mx-1 px-1 bghighlight">
                            <div class="row">
                                <div class="text-label">Native Address</div>
                            </div>
                            <div class="row text-right">
                                <div>{{ViewData[0].NativeAddress}}</div>
                            </div>
                            <!-- <label class="small-light-label heading">Native Address</label><br />
                            <label class="Label1">{{ViewData[0].NativeAddress}} </label> -->
                        </div>
                    </div>
                    <div class="row" style="margin-top: 3px;">
                        <div class="col-md mx-1 px-1 bghighlight">
                            <div class="row">
                                <div class="text-label">Age</div>
                            </div>
                            <div class="row text-right">
                                <div>{{ViewData[0].Age}}</div>
                            </div>
                            <!-- <label class="small-light-label heading">Age</label><br />
                            <label class="Label1">{{ViewData[0].Age}} </label> -->
                        </div>
                        <div class="col-md mx-1 px-1 bghighlight">
                            <div class="row">
                                <div class="text-label">Height</div>
                            </div>
                            <div class="row text-right">
                                <div>{{ViewData[0].Height}}</div>
                            </div>
                            <!-- <label class="small-light-label heading">Height</label><br />
                            <label class="Label1">{{ViewData[0].Height}} </label> -->
                        </div>
                        <div class="col-md mx-1 px-1 bghighlight">
                            <div class="row">
                                <div class="text-label">Weight</div>
                            </div>
                            <div class="row text-right">
                                <div>{{ViewData[0].Weight}}</div>
                            </div>
                            <!-- <label class="small-light-label heading">Weigth</label><br />
                            <label class="Label1">{{ViewData[0].Weight}} </label> -->
                        </div>
                        <div class="col-md mx-1 px-1 bghighlight">
                            <div class="row">
                                <div class="text-label">DOB</div>
                            </div>
                            <div class="row text-right">
                                <div>{{ViewData[0].DateOfBirth}}</div>
                            </div>
                            <!-- <label class="small-light-label heading">DOB</label><br />
                            <label class="Label1">{{ViewData[0].DateOfBirth}} </label> -->
                        </div>
                    </div>
                    <div class="row" style="margin-top: 3px;">
                        <div class="col-md mx-1 px-1 bghighlight">
                            <div class="row">
                                <div class="text-label">DOJ</div>
                            </div>
                            <div class="row text-right">
                                <div>{{ViewData[0].DateOfJoining}}</div>
                            </div>
                            <!-- <label class="small-light-label heading">DOJ</label><br />
                            <label class="Label1">{{ViewData[0].DateOfJoining}} </label> -->
                        </div>
                        <div class="col-md mx-1 px-1 bghighlight">
                            <div class="row">
                                <div class="text-label">Aadhar Number</div>
                            </div>
                            <div class="row text-right">
                                <div>{{ViewData[0].AadharNo}}</div>
                            </div>
                            <!-- <label class="small-light-label heading">Aadhar Number</label><br />
                            <label class="Label1">{{ViewData[0].AadharNo}}</label> -->
                        </div>
                        <div class="col-md mx-1 px-1 bghighlight">
                            <div class="row">
                                <div class="text-label">Pan Number</div>
                            </div>
                            <div class="row text-right">
                                <div>{{ViewData[0].PANNo}}</div>
                            </div>
                            <!-- <label class="small-light-label heading">Pan Number</label><br />
                            <label class="Label1">{{ViewData[0].PANNo}}</label> -->
                        </div>
                    </div>
                </div>
            </div>

            <div class="card" style="border-radius: 0%;">
                <div class="card-header">
                    Posting Order
                </div>
                <div class="card-body">
                    <div class="row" style="margin-top: 3px;">
                        <div class="col-md mx-1 px-1 bghighlight">
                            <div class="row">
                                <div class="text-label">Current Branch</div>
                            </div>
                            <div class="row text-right">
                                <div>{{ViewData[0].BranchName}}</div>
                            </div>
                            <!-- <label class="small-light-label heading">Current Branch</label><br />
                            <label class="Label1">{{ViewData[0].BranchName}} </label> -->
                        </div>
                        <div class="col-md mx-1 px-1 bghighlight">
                            <div class="row">
                                <div class="text-label">Current Client</div>
                            </div>
                            <div class="row text-right">
                                <div>{{ViewData[0].ClientGroupName}}</div>
                            </div>
                            <!-- <label class="small-light-label heading">Current Client</label><br />
                            <label class="Label1">{{ViewData[0].ClientGroupName}}</label> -->
                        </div>
                        <div class="col-md mx-1 px-1 bghighlight">
                            <div class="row">
                                <div class="text-label">Current Site</div>
                            </div>
                            <div class="row text-right">
                                <div>{{ViewData[0].SiteName}}</div>
                            </div>
                            <!-- <label class="small-light-label heading">Current Site</label><br />
                            <label class="Label1">{{ViewData[0].SiteName}}</label> -->
                        </div>
                        <div class="col-md mx-1 px-1 bghighlight">
                            <div class="row">
                                <div class="text-label">Site Supervisor</div>
                            </div>
                            <div class="row text-right">
                                <div>{{ViewData[0].SiteSuperVisorName}}</div>
                            </div>
                            <!-- <label class="small-light-label heading">Site Supervisor</label><br />
                            <label class="Label1">{{ViewData[0].SiteSuperVisorName}}</label> -->
                        </div>
                    </div>

                </div>
            </div>
            <div class="card" style="border-radius: 0%;">
                <div class="card-header">
                    Statutory Details
                </div>
                <div class="card-body">
                    <div class="row" style="margin-top: 3px;">
                        <div class="col-md mx-1 px-1 bghighlight">
                            <div class="row">
                                <div class="text-label">ESIC Number</div>
                            </div>
                            <div class="row text-right">
                                <div>{{ViewData[0].ESICNo}}</div>
                            </div>
                            <!-- <label class="small-light-label heading">ESIC Number</label><br />
                            <label class="Label1">{{ViewData[0].ESICNo}}</label> -->
                        </div>
                        <div class="col-md mx-1 px-1 bghighlight">
                            <div class="row">
                                <div class="text-label">PF Number</div>
                            </div>
                            <div class="row text-right">
                                <div>{{ViewData[0].PFNo}}</div>
                            </div>
                            <!-- <label class="small-light-label heading">PF Number</label><br />
                            <label class="Label1">{{ViewData[0].PFNo}}</label> -->
                        </div>
                        <div class="col-md mx-1 px-1 bghighlight">
                            <div class="row">
                                <div class="text-label">UAN Number</div>
                            </div>
                            <div class="row text-right">
                                <div>{{ViewData[0].UANNo}}</div>
                            </div>
                            <!-- <label class="small-light-label heading">UAN Number</label><br />
                            <label class="Label1">{{ViewData[0].UANNo}}</label> -->
                        </div>
                    </div> 
                </div>
            </div>
            <!-- <div class="row" style="margin-top: 3px;">
            </div> -->
            <div class="card" style="border-radius: 0%;">
                <div class="card-header">
                    Bank Details
                </div>
                <div class="card-body">
                    <div class="row" style="margin-top: 3px;">
                        <div class="col-md mx-1 px-1 bghighlight">
                            <div class="row">
                                <div class="text-label">Bank Name</div>
                            </div>
                            <div class="row text-right">
                                <div>{{ViewData[0].BankName}}</div>
                            </div>
                            <!-- <label class="small-light-label heading">Bank Details</label><br />
                            <label class="Label1">{{ViewData[0].BankName}}</label> -->
                        </div>
                        <div class="col-md mx-1 px-1 bghighlight">
                            <div class="row">
                                <div class="text-label">Account No</div>
                            </div>
                            <div class="row text-right">
                                <div>{{ViewData[0].Accountno}}</div>
                            </div>
                            <!-- <label class="small-light-label heading">Account No</label><br />
                            <label class="Label1">{{ViewData[0].Accountno}}</label> -->
                        </div>
                        <div class="col-md mx-1 px-1 bghighlight">
                            <div class="row">
                                <div class="text-label">IFSCode</div>
                            </div>
                            <div class="row text-right">
                                <div>{{ViewData[0].IFSCode}}</div>
                            </div>
                            <!-- <label class="small-light-label heading">IFSCode</label><br />
                            <label class="Label1">{{ViewData[0].IFSCode}}</label> -->
                        </div>
                        <div class="col-md mx-1 px-1 bghighlight">
                            <div class="row">
                                <div class="text-label">Name As Per Bank</div>
                            </div>
                            <div class="row text-right">
                                <div>{{ViewData[0].NameAsPerBank}}</div>
                            </div>
                            <!-- <label class="small-light-label heading">Name As Per Bank</label><br />
                            <label class="Label1">{{ViewData[0].NameAsPerBank}}</label> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="card-footer">
        <div class="row">
            <div class="col">
                <div class="row">
                </div>
                <div class="row">
                </div>
            </div>
            <div class="col-auto">
                <button type="button" class="btn btn-outline-primary" [disabled]="isDisabled" (click)="Cancel()"
                    autofocus="true" #cancelButton id="cancelButton">
                    <i class="bi bi-x-lg" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Cancel':'Loading...'}}
                </button>
            </div>
        </div>
    </div>
</div>